module.exports = __webpack_public_path__ + "img/icon.4e5c1518.png";